module.exports = __webpack_public_path__ + "media/images/article/2021_arr-d9043b4036bd4f180c4ddcfceb86882e.png";